import costCenterNumbersQueries from '@/api/modules/costCenterNumbersQueries'
import { FINANCES } from '@/constants'
import { t } from '@/i18n'
import { handleApiError } from '@/utils/apiHelpers'

class CostCenterNumbersService {
    async fetchCostCenterNumbers(queryString = '') {
        try {
            const searchParams = new URLSearchParams(queryString)
            searchParams.set('channelId', String(FINANCES.CHANNEL.COMMON))
            const response = await costCenterNumbersQueries.fetchCostCenterNumbers(searchParams)
            const data = response?.data
            const rawResults = Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : []

            return rawResults.map((item) => ({
                ...item,
                verboseName: `${item.number} - ${item.description}`
            }))
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.fetchCostCenterNumbersError'))
            throw error
        }
    }
}

export const useCostCenterNumbersService = (options) => new CostCenterNumbersService(options)
